export class AtcCodeContentModel {
    public langId: number;
    public atcCodeName: string;
}